/**
 * Created by Rain Laansalu on 03.11.2017.
 */

import {apiUrl} from "../js/constants";

function apiRequest(data, callback, url)
{
    if(!url){
        url = apiUrl;
    }
    $.ajax({
        method: 'POST',
        url: url,
        beforeSend: function(request){
            // if(localStorage.getItem('JWT')){
            //     // console.log("siin");
            //     request.setRequestHeader('Authorization', 'Bearer '+localStorage.getObj('JWT'));
            //     // request.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('JWT'));
            // }
        },
        dataType: 'JSON',
        data: data,
        success: function(data){
            // if(data.JWT){
            //     localStorage.setObj('JWT',data.JWT);
            // }
            if(data.response){
                callback(data.response);
            }else{
                callback(data);
            }
            // Prevent concurrency issues if subscriptionId changes often:
            // you are only interested in the results of the last ajax
            // request that was made.
            // if ( self.props.subscriptionId === subscriptionId ) {
            // self.setState({
            //     response: data
            // });
            // }
        }
    });
}

export {apiRequest}



//////////////////
// WEBPACK FOOTER
// ./src/js/main.js
// module id = 2
// module chunks = 0